import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from 'jquery';
import classNames from 'classnames';
import CommentUtil from '../../util/CommentUtil';
import AnnotationUtil from '../../queries/annotations/AnnotationUtil';
import FileInfoUtil from '../../util/FileInfoUtil';
import { CommentFilterOption } from '../../util/Constants';
import { AnnotationThread, SaveAnnotationsResponse } from './../../autogenerated/ZoomBridge';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import loginRequired from '../../auth/loginRequired';
import { isWaveplayerComment } from '../../util/VideoUtil';
import { useNewImagePreview } from '../../util/FeatureUtil';
import { isXsScreen, isMobile, getInnerWidth } from '../../util/ScreenUtil';
import Store from '../../store/Store';
import StoreListener from '../../store/StoreListener';
import ViewUtil from '../../ViewUtil';
import { setGlobalProgress } from '../../store/StoreUtil';
import { getErrorMessage } from '../../util/ErrorUtil';
import AddCommentForm from './AddCommentForm';
import BrowseCommentForm from './BrowseCommentForm';
import EditCommentChain from './EditCommentChain';
import AssetVideoPreview from '../AssetVideoPreview';
import AssetImagePreview from '../AssetImagePreview';
import {
  ACTIVE_COMMENT_ID,
  SHOW_COMMENTS,
  COMMENTS,
  PERMISSIONS,
  MULTIPAGE_ASSET_CURRENT_PAGE,
  COMMENT_TEXT,
  SELECTED_ASSET,
  SELECTED_COLLECTION
} from '../../store/Constants';
import './CollectionAssetView.css';
import LazyLoad from '../../lazyload/LazyLoad';
import StoreDataChangeEvent from '../../store/StoreDataChangeEvent';
import GetAnnotations from '../../queries/annotations/GetAnnotations';
import CollectionUtil from '../../queries/lightbox/CollectionUtil';
import { WITH_UNIRESIZABLE_COLUMN } from '../../hoc/withUniResizableColumn_Constant';

// const AddCommentForm = LazyLoad(() => import('./AddCommentForm'));
// const BrowseCommentForm = LazyLoad(() => import('./BrowseCommentForm'));
// const EditCommentChain = LazyLoad(() => import('./EditCommentChain'));
// const AssetVideoPreview = LazyLoad(() => import('../AssetVideoPreview'));
// const AssetImagePreview = LazyLoad(() => import('../AssetImagePreview'));

const debug = require('../../debug/debug')('wc:collections:CollectionAssetView');

const storeItems = [
  { name: SHOW_COMMENTS, defaultValue: true },
  { name: ACTIVE_COMMENT_ID, defaultValue: null },
  { name: COMMENTS, defaultValue: [] },
  { name: PERMISSIONS, defaultValue: {} }
];

@StoreListener(storeItems)
export default class CollectionAssetView extends React.Component {
  static GET_ANNOTATIONS: string = 'GET_ANNOTATIONS';
  static propTypes = {
    collection: PropTypes.object.isRequired,
    asset: PropTypes.object.isRequired,
    showAllComments: PropTypes.any,
    onReceiveComments: PropTypes.func,
    onClickOnCommentMarker: PropTypes.func,
    onReplyClicked: PropTypes.func,
    onGlobalCommentClick: PropTypes.func,
    setSpatialBrowseComment: PropTypes.func,
    setSpatialEditComment: PropTypes.func,
    blockVideoKeyEvents: PropTypes.bool,
    allowFullscreen: PropTypes.bool,
    onFullScreenToggle: PropTypes.func,
    fastRemoveResolvedComment: PropTypes.func,
    onReceiveReviews: PropTypes.func,
    localUserReviewAnnotation: PropTypes.object,
    createLocalUser: PropTypes.func,
    filteredComments: PropTypes.any,
    isInFullscreenMode: PropTypes.bool.isRequired,
    isMultiPage: PropTypes.bool,
    pdfPreviewOption: PropTypes.string,
    compareViewRevisionIndex: PropTypes.any,
    getFullScreenNode: PropTypes.func,
    onFullScreenChange: PropTypes.func,
    onEditDialogClosed: PropTypes.func,
    onCloseBrowseCommentForm: PropTypes.func,
    comments: PropTypes.array,
    addMouseListener: PropTypes.func,
    removeMouseListener: PropTypes.func,
    fullscreenControlsOffset: PropTypes.number,
    scrollNode: PropTypes.object,
    waveplayer: PropTypes.bool,
    activeCommentIdInPanel: PropTypes.number,
    useLocalComments: PropTypes.bool,
    renderDownloadButton: PropTypes.func,
    [SHOW_COMMENTS]: PropTypes.bool,
    [COMMENTS]: PropTypes.array,
    [PERMISSIONS]: PropTypes.object,
    registerRefreshCallback: PropTypes.func
  };

  static defaultProps = {
    showAllComments: CommentFilterOption.ALL,
    onReceiveComments: $.noop,
    onClickOnCommentMarker: $.noop,
    setSpatialBrowseComment: $.noop,
    setSpatialEditComment: $.noop,
    blockVideoKeyEvents: false,
    allowFullscreen: true,
    isInFullscreenMode: false,
    compareViewRevisionIndex: -1,
    onEditDialogClosed: $.noop,
    onCloseBrowseCommentForm: $.noop
  };

  constructor(props) {
    super(props);

    this.state = {
      showBrowseCommentFormOnCreate: false,
      browseCommentPosition: null,
      localComments: [],
      currentPage: props.isMultiPage ? 1 : undefined,
      useNewImagePreview: useNewImagePreview() && !this.isVideo(),
      formContainerOverrideStyle: {}
    };

    this.commentTimestamps = [];
    this.lastReceidedCommentsRrn = 0;
    this.savingAnnotations = false;
    this.thumbnailService = new ThumbnailUtil(1);
    this.onSvgClick = this.onSvgClick.bind(this);
  }

  componentDidMount() {
    if (!this.state.useNewImagePreview) {
      this.initCanvas();
      this.SVGClickOn();
    }
    if (this.props.registerRefreshCallback) {
      this.props.registerRefreshCallback(this.loadAnnotations);
    }
    Store.put(COMMENTS, []);
    this.loadAnnotations();
    this.reloadAnnotationsInterval = setInterval(() => {
      this.loadAnnotations();
    }, 10000);
    Store.GLOBAL_STORE.once(
      CollectionAssetView.GET_ANNOTATIONS,
      this.markCommentAsReadAfterSomeTimeWhenCommentsAreLoaded
    );
  }

  markCommentAsReadAfterSomeTimeWhenCommentsAreLoaded = (e: StoreDataChangeEvent<GetAnnotations>) => {
    const unreadCommentIds: Array<number> = [];
    const getAnnotation: ?GetAnnotations = e.data;
    if (getAnnotation) {
      const fuidRrnInfo = AnnotationUtil.toFuidRrnInfo(
        this.props.asset.getFuid(),
        this.props.asset.getBid(),
        this.props.asset.getRrn()
      );
      /* const unreadCmmentsIdFromGlobal = CommentUtil.getUnreadCommentIdsCollectionAndFuid(
        this.props.collection.getCollectionId(),
        (f) => fuidRrnInfo.getFuid() == f.getFuid() && fuidRrnInfo.getRrn() == f.getRrn()
      ); */
      const unreadCommentIds: Array<number> = CommentUtil.getUnreadCommentIdsInTheseThreads(
        getAnnotation.getReviewAnnotations()
      );
      if (unreadCommentIds && unreadCommentIds.length > 0) {
        CommentUtil.markCommentIdsAsRead(unreadCommentIds);
        console.log('Marking review comments as read: ', unreadCommentIds);
      }
      //console.log('Unread comments ids from annotaions parsing: ', unreadCommentIds, unreadCmmentsIdFromGlobal);
    }

    // const collectionId: number = this.props.collection.getCollectionId();
  };

  componentWillReceiveProps(nextProps) {
    const comments = nextProps.filteredComments || nextProps.comments || this.state.localComments;
    this.mapCommentsToTimestamp(comments);
  }

  componentWillUnmount() {
    this.SVGClickOff();
    clearInterval(this.initCanvasIt);
    // clearInterval(this.videoRenderInverval);
    clearInterval(this.reloadAnnotationsInterval);
    Store.put(COMMENTS, []);
    Store.put(CollectionAssetView.GET_ANNOTATIONS, undefined);
  }

  componentDidUpdate(prevProps) {
    if (this.checkIfRedirectedFromComments()) {
      //Url check for comment nav..
      this.openCommentWhenRedirected(); //Open the comment...
    }

    //const activeCommentId = this.props[ACTIVE_COMMENT_ID];
    //if (prevProps[ACTIVE_COMMENT_ID] !== activeCommentId && activeCommentId) {
    //setTimeout(() => this.forceUpdate(), 100);
    //}

    if (this.props[ACTIVE_COMMENT_ID] && prevProps[ACTIVE_COMMENT_ID] != this.props[ACTIVE_COMMENT_ID]) {
      if (this.props[ACTIVE_COMMENT_ID] === -1) {
        this.setState({ browseComment: null, clickedOnMarker: false });
      }
      const comment = this.findActiveCommentByCommentId(this.props[ACTIVE_COMMENT_ID]);
      if (!comment) {
        return;
      }
      this.setState({ browseComment: comment, clickedOnMarker: true });
    }

    if (this.props.waveplayer != prevProps.waveplayer && !this.props.waveplayer) {
      this.initCanvas();
    }
  }

  get assetImagePreview() {
    const { assetImagePreview } = this.refs;
    try {
      return assetImagePreview._component._component._component._component;
    } catch (err) {
      return assetImagePreview;
    }
  }

  isVideo = () => {
    return FileInfoUtil.isAudioOrVideo(this.props.asset);
  };

  initCanvas = () => {
    this.initCanvasIt = setInterval(() => {
      if (this.assetImagePreview) {
        this.canvas = this.assetImagePreview.refs.drawingCanvas;
        if (this.canvas) {
          clearInterval(this.initCanvasIt);
        }
      }
    }, 100);
  };

  updateCommentList(from, to) {
    this.filterNewOrModifiedComments(from, to);
    return _.concat(from, to);
  }

  filterNewOrModifiedComments(from, to) {
    _.remove(from, (fromEl) => {
      return _.find(to, (toEl) => {
        return fromEl.getThreadId() === toEl.getThreadId();
      });
    });
  }

  //To check if redirected from clicking comment on any notification panel
  checkIfRedirectedFromComments() {
    const { cId, tId } = window.ARGS;
    return tId || cId;
  }

  //Scroll to comment and focus/open it when user has navigated to comments by clicking external link
  openCommentWhenRedirected = () => {
    debug('[openCommentWhenRedirected()] begin');
    const { cId, tId } = window.ARGS;
    if (!cId || !tId) {
      return;
    }
    const args = { ...window.ARGS };
    delete args.cId;
    delete args.tId;
    ViewUtil.setARGS(args, true);

    const thread: AnnotationThread = this.getValidComments().find(
      (annotation) => annotation.getThreadId() === parseInt(cId) || annotation.getThreadId() === parseInt(tId)
    );

    const openComments = () => {
      //mark comment as read
      const thread: AnnotationThread = this.getValidComments().find(
        (annotation) => annotation.getThreadId() === parseInt(cId) || annotation.getThreadId() === parseInt(tId)
      );

      if (!thread) {
        console.warn('Comment id not found in collection', cId, 'thread id', tId);
        if (this.props.asset) {
          CommentUtil.markCommentAsRead(parseInt(tId), FileInfoUtil.createFuidRrnInfo(this.props.asset), cId);
        }
        return;
      } else {
        CommentUtil.markCommentAsReadIfNeeded(thread, true);
      }

      debug('[openCommentWhenRedirected()] setting ACTIVE_COMMENT_ID: ', thread.getThreadId());
      Store.put(ACTIVE_COMMENT_ID, thread.getThreadId());
      if (this.props.isMultiPage) {
        const page = AnnotationUtil.getPageNumber(thread);
        debug('[openCommentWhenRedirected()] setting MULTIPAGE_ASSET_CURRENT_PAGE: ', page);
        Store.put(MULTIPAGE_ASSET_CURRENT_PAGE, page);
      }
    };
    if (thread) {
      openComments();
    } else {
      //this.fatchCommentWhenNeed();
      const asset = Store.get(SELECTED_ASSET);
      const collection = Store.get(SELECTED_COLLECTION);
      if (asset && collection) {
        const info = AnnotationUtil.repoItemToFuidRrnInfo(asset);
        this.loadAnnotations(() => {
          openComments();
        });
      }
    }
    return;
  };

  fatchCommentWhenNeed = () => {
    const asset = Store.get(SELECTED_ASSET);
    const collection = Store.get(SELECTED_COLLECTION);
    if (asset && collection) {
      const info = AnnotationUtil.repoItemToFuidRrnInfo(asset);
      this.loadAnnotations();
    }
  };

  count: number = 0;
  /**
   *
   * @param {Function} callbackFunc
   */
  loadAnnotations = (callbackFunc) => {
    if (this.getAnnotationIsInProgress) {
      if (callbackFunc) {
        Store.once(COMMENTS, function () {
          callbackFunc();
        });
      }
      return;
    }
    this.getAnnotationIsInProgress = true;
    this.count++;
    AnnotationUtil.getAnnotations(
      AnnotationUtil.repoItemToFuidRrnInfo(this.props.asset),
      this.props.collection.getCollectionId(),
      // this.lastReceidedCommentsRrn,
      0,
      (getAnnotations) => {
        this.getAnnotationIsInProgress = false;
        let annotations: AnnotationThread[] = getAnnotations.getAnnotations() || [];
        const lastRrn = getAnnotations.getLastReceivedRrn();
        if (lastRrn !== this.lastReceidedCommentsRrn) {
          //if (lastRrn === this.lastReceidedCommentsRrn || lastRrn === 0) return;
          if (!annotations) {
            annotations = [];
          }

          let annotationThreads: AnnotationThread[] = annotations;
          const comments = this.updateCommentList(this.getValidComments(), annotations);
          if (this.isActiveComment()) {
            this.replaceActiveComment(this.findActiveComment(comments));
          }
          this.lastReceidedCommentsRrn = lastRrn !== 0 ? lastRrn : this.lastReceidedCommentsRrn;
          this.setState({ localComments: comments });
          Store.put(COMMENTS, annotations);
          Store.put(CollectionAssetView.GET_ANNOTATIONS, getAnnotations);
          this.handleReviewAnnotations(getAnnotations.getReviewAnnotations());

          this.stopProgressAnimation();
          setTimeout(() => window.render(), 100);
          if (this.props.onReceiveReviews) {
            this.props.onReceiveReviews(getAnnotations.getReviewAnnotations());
          }
          this.props.onReceiveComments(comments);
        }
        this.getAnnotationIsInProgress = false;
        if (callbackFunc) {
          callbackFunc();
        }
      }
    );
  };

  handleReviewAnnotations(reviewAnnotations: AnnotationThread[]) {
    if (!this.props.createLocalUser) return;
    //  this.loadAnnotations(() => {
    let reviewSet: boolean = false;
    for (let index = 0; index < reviewAnnotations.length; index++) {
      const element: AnnotationThread = reviewAnnotations[index];
      if (AnnotationUtil.isReviewAnnotation(element)) {
        const isCreator = AnnotationUtil.isIamCreatorOfThisThread(element);
        if (isCreator) {
          reviewSet = true;
          this.props.createLocalUser(element);
          return;
        }
      }
    }
    if (!reviewSet) {
      this.props.createLocalUser(AnnotationUtil.createReview());
    }
  }

  getValidComments() {
    if (this.props.useLocalComments) {
      return this.state.localComments;
    }

    const { comments = [] } = this.props;
    return [...comments];
    //return comments.length ? [...comments] : this.state.localComments;
  }

  mapCommentsToTimestamp(comments) {
    this.commentTimestamps = [];
    _.each(comments, (comment) => {
      const temporal = AnnotationUtil.getTemporalLocation(comment);
      if (temporal) {
        this.commentTimestamps.push(AnnotationUtil.getVideOffsetInMilliseconds(comment));
      }
    });
    this.commentTimestamps = _.sortBy(this.commentTimestamps);
  }

  findActiveCommentByCommentId = (commentId) => {
    const { comments = [] } = this.props;
    return _.find(comments, (comment) => {
      if (commentId === AnnotationUtil.getRootAnnotation(comment).getCommentId()) return comment;
    });
  };

  findActiveComment = (comments) => {
    const activeComment = this.getActiveComment();
    return _.find(comments, (comment) => {
      return (
        AnnotationUtil.getRootAnnotation(activeComment).getCommentId() ===
        AnnotationUtil.getRootAnnotation(comment).getCommentId()
      );
    });
  };

  replaceActiveComment = (newComment) => {
    if (this.state.editComment) {
      // this.refs.addCommentForm.setState({ comment: newComment });
      this.setState({ editComment: newComment });
    }
    if (this.state.editCommentChain) {
      this.refs.editCommentChain.setState({ comment: newComment });
      this.refs.editCommentChain.refs.addCommentForm.setState({ comment: newComment });
      this.setState({ editCommentChain: newComment });
    }
    if (this.state.browseComment) {
      if (this.refs.browseCommentForm) {
        this.refs.browseCommentForm.setState({ comment: newComment });
      }
      this.setState({ browseComment: newComment });
      this.props.setSpatialBrowseComment(newComment);
    }
    if (this.state.browseCommentChain) {
      this.refs.browseCommentForm.setState({ comment: newComment });
      this.setState({ browseCommentChain: newComment });
    }
  };

  getActiveComment = () => {
    if (this.state.editComment) return this.state.editComment;
    if (this.state.editCommentChain) return this.state.editCommentChain;
    if (this.state.browseComment) return this.state.browseComment;
    if (this.state.browseCommentChain) return this.state.browseCommentChain;
    if (this.state.addingComment) return this.state.addingComment.comment;
    return null;
  };

  isActiveComment = () => {
    return this.getActiveComment() !== null;
  };

  calculateMarkerPosition = (marker) => {
    if (!this.canvas) {
      return marker;
    }

    const display = this.canvas.getDisplayProps();
    if (!display) {
      return {
        top: '50%',
        left: '50%'
      };
    } else if (this.assetImagePreview.state.imageNormalFits) {
      return {
        top: `calc(50% - ${display.height / 2 - marker.top}px)`,
        left: `calc(50% - ${display.width / 2 - marker.left}px)`
      };
    } else {
      return {
        top: marker.top * this.canvas.state.scale + display.y,
        left: marker.left * this.canvas.state.scale + display.x
      };
    }
  };

  isVideoKeyEventsBlocked = () => {
    return !(
      !this.state.addingComment &&
      !this.state.browseComment &&
      !this.state.browseCommentChain &&
      !this.state.editComment &&
      !this.state.editCommentChain &&
      !this.state.isDragging
    );
  };

  onShapeCreated = (shape) => {
    const display = this.canvas.getDisplayProps();
    this.createNewComment(
      {
        nativeEvent: {
          offsetX: display.width / 2,
          offsetY: display.height / 2
        }
      },
      shape.getData()
    );
  };

  drawAssetPreview() {
    const {
      asset,
      collection,
      isMultiPage,
      pdfPreviewOption,
      isInFullscreenMode,
      getFullScreenNode,
      onFullScreenChange,
      addMouseListener,
      removeMouseListener,
      fullscreenControlsOffset,
      waveplayer,
      activeCommentIdInPanel,
      useLocalComments,
      renderDownloadButton,
      compareViewRevisionIndex
    } = this.props;

    const { canViewComments } = this.props[PERMISSIONS];

    if (this.isVideo() || FileInfoUtil.is3DAsset(asset)) {
      return (
        <AssetVideoPreview
          ref="assetImagePreview"
          setColWidth={this.props.setContainerWidth}
          widthOfCol={this.props.containerWidth}
          getMaxWidth={() => getInnerWidth() - 300}
          getMinWidth={() => getInnerWidth() - 700}
          isUpdateWithScreenResize={true}
          allowFullscreen={this.props.allowFullscreen}
          onFullScreenToggle={this.props.onFullScreenToggle}
          selectedAsset={asset}
          shapeDrawingStart={this.DCShapeDrawingStart}
          shapeDrawingStop={this.DCShapeDrawingStop}
          comments={this.props.filteredComments ? this.props.filteredComments : this.getValidComments()}
          commentFilter={this.props.showAllComments}
          isExpandedMode={isInFullscreenMode}
          onRender={() => {
            if (this.canvas && this.prevScale !== this.canvas.state.scale) {
              this.prevScale = this.canvas.state.scale;
            }
          }}
          onCommentButtonClick={(timestamp) => {
            this.onCommentButtonClick(timestamp);
          }}
          onGotoPrevComment={(timestamp) => this.onGotoPrevComment(timestamp)}
          onGotoNextComment={(timestamp) => this.onGotoNextComment(timestamp)}
          onProgress={this.onVideoProgress}
          onSeekChange={(progress) => {
            this.onVideoSeek(progress);
          }}
          blockKeyEvents={this.isVideoKeyEventsBlocked() || this.props.blockVideoKeyEvents}
          enableComments={canViewComments}
          onClickThroughShape={(evt) => this.onClickOverImage(evt)}
          addingShape={this.state.addingComment ? this.state.addingComment.comment : null}
          onShapeCreated={this.onShapeCreated}
          onShapeDeleted={this.onShapeDeleted}
          onShapeDrag={this.onShapeDrag}
          onShapeDragEnd={this.onShapeDragEnd}
          getFullScreenNode={getFullScreenNode}
          onFullScreenChange={onFullScreenChange}
          addMouseListener={addMouseListener}
          removeMouseListener={removeMouseListener}
          fullscreenControlsOffset={fullscreenControlsOffset}
          waveplayer={waveplayer}
          useLocalComments={useLocalComments}
          renderDownloadButton={renderDownloadButton}
          compareViewRevisionIndex={compareViewRevisionIndex}
          isCompareMode={this.props.isCompareMode}
        />
      );
    } else {
      return (
        <AssetImagePreview
          ref="assetImagePreview"
          asset={asset}
          setColWidth={this.props.setContainerWidth}
          widthOfCol={this.props.containerWidth}
          getMaxWidth={() => getInnerWidth() - 300}
          getMinWidth={() => getInnerWidth() - 700}
          isUpdateWithScreenResize={true}
          collection={collection}
          allowFullscreen={this.props.allowFullscreen}
          onFullScreenToggle={this.props.onFullScreenToggle}
          selectedAsset={asset}
          shapeDrawingStart={this.DCShapeDrawingStart}
          shapeDrawingStop={this.DCShapeDrawingStop}
          onRender={() => {
            if (this.canvas && this.prevScale !== this.canvas.state.scale) {
              this.prevScale = this.canvas.state.scale;
            }
          }}
          isExpandedMode={isInFullscreenMode}
          onClickThroughShape={(evt) => this.onClickOverImage(evt)}
          enableComments={canViewComments}
          comments={this.props.filteredComments ? this.props.filteredComments : this.getValidComments()}
          addingShape={this.state.addingComment ? this.state.addingComment.comment : null}
          onShapeCreated={this.onShapeCreated}
          onShapeDeleted={this.onShapeDeleted}
          onShapeDrag={this.onShapeDrag}
          onShapeDragEnd={this.onShapeDragEnd}
          isMultiPage={isMultiPage}
          onPageChange={this.onPageChange}
          pdfPreviewOption={pdfPreviewOption}
          getFullScreenNode={getFullScreenNode}
          onFullScreenChange={onFullScreenChange}
          addMouseListener={addMouseListener}
          removeMouseListener={removeMouseListener}
          saveAnnotation={this.saveAnnotation}
          saveReply={this.onNewReply}
          deleteReply={this.onReplyRemove}
          activeCommentIdInPanel={activeCommentIdInPanel}
          renderDownloadButton={renderDownloadButton}
          isNotificationPanelVisible={this.props.isNotificationPanelVisible}
        />
      );
    }
  }

  onPageChange = (pageNum) => {
    this.setState({ currentPage: pageNum });
  };

  onShapeDeleted = (shape) => {
    this.onCommentRemove(shape);
  };

  onShapeDrag = (shape, newPos) => {
    AnnotationUtil.setWidthAndHeightOffset(shape.comment, newPos.x, newPos.y);
    this.setState({ isDragging: null });
  };

  onShapeDragEnd = (shape) => {
    this.saveAnnotation(shape.comment);
    this.setState({ isDragging: null });
  };

  getFormContainerStyle = (comment: AnnotationThread) => {
    const { formContainerOverrideStyle } = this.state;
    const initialMarkerPos = {
      top: AnnotationUtil.getHeightOffset(comment),
      left: AnnotationUtil.getWidthOffset(comment)
    };
    const markerPos = this.calculateMarkerPosition(initialMarkerPos);

    if (!markerPos) {
      return null;
    }

    if (!this.refs.container) {
      return null;
    }

    const baseStyle = {
      position: 'absolute',
      width: 340,
      zIndex: 130
    };

    const rect = this.refs.container.getBoundingClientRect();

    if (typeof markerPos.left === 'string') {
      const targetNode = this.refs.container.querySelector('canvas');
      if (targetNode) {
        const targetRect = targetNode.getBoundingClientRect();
        markerPos.top = initialMarkerPos.top + targetRect.top - rect.top;
        markerPos.left = initialMarkerPos.left + targetRect.left - rect.left;
      }
    }

    const FORM_WIDTH = 340;
    const tooWide = markerPos.left + FORM_WIDTH > rect.right;

    if (isMobile()) {
      let left = Math.max(markerPos.left, 20);
      left = Math.min(markerPos.left, rect.width - FORM_WIDTH - 20);
      return {
        ...baseStyle,
        top: markerPos.top,
        left: isXsScreen() ? (rect.width - FORM_WIDTH) / 2 : left
      };
    }

    if (isWaveplayerComment(comment)) {
      return {
        ...baseStyle,
        top: initialMarkerPos.top,
        left: tooWide ? initialMarkerPos.left - FORM_WIDTH : initialMarkerPos.left,
        ...formContainerOverrideStyle
      };
    }
    return {
      ...baseStyle,
      top: markerPos.top,
      left: tooWide ? markerPos.left - FORM_WIDTH : markerPos.left,
      ...formContainerOverrideStyle
    };
  };

  getBottomBarOffset = () => {
    const { container } = this.refs;
    if (!container) {
      return;
    }

    const canvasContainer = container.querySelector('.DrawingCanvasContainer');
    if (!canvasContainer) {
      return 0;
    }

    const containerHeight = container.getBoundingClientRect().height;
    const canvasContainerHeight = canvasContainer.getBoundingClientRect().height;
    return containerHeight - canvasContainerHeight;
  };

  /**
   * This method determines if the comment popup should switch
   * from showing below the marker to above.
   */
  onCommentFormMount = (node) => {
    const { scrollNode } = this.props;
    if (!node) {
      return;
    }

    if (!this.refs.container) {
      return;
    }

    const containerRect = this.refs.container.getBoundingClientRect();
    const rect = node.getBoundingClientRect();
    const bottomBarOffset = this.getBottomBarOffset();
    const diff = rect.bottom - containerRect.bottom + bottomBarOffset;

    if (diff <= 0) {
      return;
    }

    const minSizeForShowAbove = rect.height + 10;
    const spaceAbove = rect.top - containerRect.top;
    if (spaceAbove < minSizeForShowAbove) {
      // Not enough room to show above, so just scroll the popup into view.
      if (node.scrollIntoView) {
        node.scrollIntoView();
      } else if (scrollNode) {
        scrollNode.scrollTop = scrollNode.scrollHeight - scrollNode.clientHeight;
      }
    } else {
      // Set the override styles to show the popup above the marker.
      const formContainerOverrideStyle = {
        top: '',
        bottom: `${containerRect.bottom - rect.top}px`
      };

      this.setState({ formContainerOverrideStyle });
    }
  };

  drawNewComment() {
    const display = this.canvas.getDisplayProps();
    if (!this.state.addingComment.placed) {
      const commentInputClickArea = this.assetImagePreview.state.imageNormalFits
        ? {
          position: 'absolute',
          top: `calc(50% - ${display.height / 2}px)`,
          left: `calc(50% - ${display.width / 2}px)`,
          width: display.width,
          height: display.height,
          zIndex: 10,
          cursor: 'pointer'
        }
        : {
          position: 'absolute',
          top: display.y,
          left: display.x,
          width: display.width,
          height: display.height,
          zIndex: 10,
          cursor: 'pointer'
        };
      return <div className="clickArea" style={commentInputClickArea} onClick={this.selectedCommentPosition} />;
    } else {
      const comment = this.state.addingComment.comment;
      const initialMarkerPos = {
        top: AnnotationUtil.getHeightOffset(comment),
        left: AnnotationUtil.getWidthOffset(comment)
      };

      const markerPos = isWaveplayerComment(comment)
        ? initialMarkerPos
        : this.calculateMarkerPosition(initialMarkerPos);

      if (!markerPos) return null;

      const style = this.getFormContainerStyle(comment);
      let newStyle = Object.assign(style, this.commentDivHorizontalPostion(markerPos.left));
      const commentIdx = comment.getAnnotationLocation().getCommentIndex();
      return (
        <div style={{ width: markerPos.left + style.width + 5, height: 1 }}>
          <div
            id={`marker${commentIdx}`}
            style={{
              ...styles.marker,
              background: CommentUtil.commentBackgroundByKind(comment),
              top: markerPos.top,
              left: markerPos.left,
              zIndex: 140
            }}
            key={commentIdx}>
            {commentIdx}
          </div>
          <div style={this.state.clickedOnMarker ? style : {}} ref={this.onCommentFormMount}>
            <AddCommentForm
              comment={comment}
              ref="addCommentForm"
              onClose={this.onAddCommentDialogClose}
              onSubmit={this.onAddCommentDialogSubmit}
            />
          </div>
        </div>
      );
    }
  }

  commentDivHorizontalPostion = (left: Number) => {
    const canvasRef = this.refs.container.querySelector('canvas');
    if (!canvasRef) return;
    let width = canvasRef.width;
    let commentStyle = {};
    let xAxisPosition = (left * 100) / width + 3;
    commentStyle = { transform: `translateX(-${xAxisPosition}%)`, left: left };
    return commentStyle;
  };

  onAddCommentDialogSubmit = (comment) => {
    this.onNewComment(comment);
    if (this._onCommentFormSubmit) {
      this._onCommentFormSubmit();
    }
  };

  onAddCommentDialogClose = () => {
    this.setState({ addingComment: null, clickedOnMarker: false, formContainerOverrideStyle: {} });
    if (this.canvas) {
      this.canvas.needUpdateOffsetY = true;
    }
    this.props.setSpatialBrowseComment(null);

    if (this._onCommentFormClose) {
      this._onCommentFormClose();
    }
  };

  drawBrowseComment() {
    if (isWaveplayerComment(this.state.browseComment)) {
      return null;
    }
    let newStyle = {};
    if (AnnotationUtil.getVideOffsetInMilliseconds(this.state.browseComment) === 0) {
      return null;
    }

    if (this.state.clickedOnMarker && !FileInfoUtil.isAudio(this.props.asset)) {
      const markerPos = this.calculateMarkerPosition({
        top: AnnotationUtil.getHeightOffset(this.state.browseComment),
        left: AnnotationUtil.getWidthOffset(this.state.browseComment)
      });
      newStyle = this.commentDivHorizontalPostion(markerPos.left);
      if (!markerPos) return null;
    } else {
      newStyle = { left: 'calc((50% - 170px))', top: '40%' };
    }
    let style = Object.assign(this.getFormContainerStyle(this.state.browseComment), newStyle);

    const isShown = this.state.showBrowseCommentFormOnCreate;
    if (isShown) this.state.showBrowseCommentFormOnCreate = false;
    return (
      <div
        style={this.state.clickedOnMarker ? style : {}}
        onMouseUp={this.onCommentMarkerDragEnd}
        ref={this.onCommentFormMount}>
        <BrowseCommentForm
          position={{ top: style.top, bottom: style.bottom }}
          ref="browseCommentForm"
          asset={this.props.asset}
          comment={this.state.browseComment}
          onClose={this.onCloseBrowseCommentForm}
          onReply={(reply, component) => this.onNewReply(reply, component)}
          onEdit={(comment) => this.onEditInPlaceComment(comment)}
          onReplyClicked={this.props.onReplyClicked}
          onReplyEdit={this.onReplyEdit}
          onReplyRemove={this.onReplyRemove}
          onResolved={this.onResolveInPlaceComment}
          onRemove={(comment) => this.onCommentRemove(comment)}
          global={!this.state.clickedOnMarker}
          showForm={isShown}
          inFullscreenMode={this.props.isInFullscreenMode ? this.props.isInFullscreenMode : false}
        />
      </div>
    );
  }

  drawBrowseCommentChain() {
    const comment = this.state.browseCommentChain;
    return (
      <BrowseCommentForm
        key={AnnotationUtil.getRootAnnotation(comment).getCommentId()}
        ref="browseCommentForm"
        asset={this.props.asset}
        comment={this.state.browseCommentChain}
        onClose={this.onCloseBrowseCommentChain}
        onReply={(reply, component) => this.onNewReply(reply, component)}
        onReplyClicked={this.props.onReplyClicked}
        onEdit={(comment) => this.onEditComment(comment)}
        onReplyEdit={this.onReplyEdit}
        onReplyRemove={this.onReplyRemove}
        onResolved={this.onResolvedComment}
        onRemove={(comment) => this.onCommentRemove(comment)}
        inFullscreenMode={this.props.isInFullscreenMode ? this.props.isInFullscreenMode : false}
      />
    );
  }

  getValidNonWavePlayerComments = () => {
    return this.getValidComments().filter((c) => !isWaveplayerComment(c));
  };

  drawCommentMarkers() {
    const { canViewComments } = this.props[PERMISSIONS];
    const { browseComment, editComment } = this.state;
    if (!this.canvas) return;

    if (!canViewComments) {
      return;
    }

    const showComments = this.props[SHOW_COMMENTS];
    if (!showComments) {
      return;
    }

    return _.map(this.getValidNonWavePlayerComments(), (comment) => {
      let additionalStyle = {};

      if (this.isVideo()) {
        const temporalPos = AnnotationUtil.getTemporalLocation(comment);
        if (!temporalPos) {
          return;
        }

        const { playing } = this.assetImagePreview.state;

        if (playing) {
          return;
        }

        const displayNow = CommentUtil.isInRange(
          AnnotationUtil.getVideOffsetInMilliseconds(comment),
          this.assetImagePreview.getProgressMillis(),
          150
        );

        if (!displayNow) {
          return;
        }

        additionalStyle.opacity = 1;
      }

      if (this.props.isMultiPage) {
        const temporalPos = AnnotationUtil.getTemporalLocation(comment);
        if (!temporalPos || this.state.currentPage !== AnnotationUtil.getPageNumber(comment)) {
          return;
        }
      }

      const pos = AnnotationUtil.getSpatialLocation(comment);
      if (pos && AnnotationUtil.getHeightOffset(comment) !== 0 && AnnotationUtil.getWidthOffset(comment) !== 0) {
        const markerPos = this.calculateMarkerPosition({
          top: AnnotationUtil.getHeightOffset(comment),
          left: AnnotationUtil.getWidthOffset(comment)
        });

        if (!markerPos) {
          return null;
        }

        const topLvl = comment === browseComment || comment === editComment;
        const isResolved = comment.isResolved();
        const activeComment = browseComment || editComment;
        if (this.isShowingAllComments()) {
          return this.drawMarker(comment, activeComment, additionalStyle, isResolved, markerPos, topLvl);
        } else if (isResolved && this.isShowingResolvedComments()) {
          return this.drawMarker(comment, activeComment, additionalStyle, isResolved, markerPos, topLvl);
        } else if (!isResolved && this.isShowingUnresolvedComments()) {
          return this.drawMarker(comment, activeComment, additionalStyle, isResolved, markerPos, topLvl);
        } else {
          return null;
        }
      }
    });
  }

  drawMarker(comment, activeComment, additionalStyle, isResolved, markerPos, topLvl) {
    const commentIdx = comment.getAnnotationLocation().getCommentIndex();
    const isActive =
      activeComment &&
      AnnotationUtil.getRootAnnotation(activeComment).getCommentId() ===
      AnnotationUtil.getRootAnnotation(comment).getCommentId();

    const className = classNames('comment-marker', {
      active: isActive,
      unread: !isActive && CommentUtil.isAnyCommentUnreadInThread(comment),
      resolved: isResolved,
      highlighted: comment.getThreadId() === this.props[ACTIVE_COMMENT_ID]
    });

    const { canWriteComments, canViewComments, isAdmin } = this.props[PERMISSIONS];

    const isCreator = CommentUtil.isCreator(comment);

    const clickProps = canViewComments ? { onClick: (evt) => this.onClickOnCommentMarker(evt, comment) } : {};

    let canDrag = isAdmin || (canWriteComments && isCreator);
    if (isResolved) {
      canDrag = false;
    }
    const dragProps = canDrag
      ? {
        onMouseDown: (evt) => this.onCommentMarkerDragStart(evt, comment),
        onMouseUp: () => this.onCommentMarkerDragEnd(),
        onDragStart: (evt) => evt.stopPropagation()
      }
      : {};

    const attrs = this.isVideo() ? { 'data-timecode': AnnotationUtil.getVideOffsetInMilliseconds(comment) } : {};

    return (
      <div
        id={`marker${commentIdx}`}
        style={{
          ...styles.marker,
          ...additionalStyle,
          backgroundColor: CommentUtil.commentBackgroundByKind(comment),
          backgroundImage: isResolved && !isActive ? 'url(images/checkmark_white.svg)' : '',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50%',
          top: markerPos.top,
          left: markerPos.left,
          zIndex: isActive ? 135 : 125,
          cursor: canDrag ? 'move' : 'pointer',
          pointerEvents: this.state.isDragging ? 'none' : 'auto',
          userSelect: 'none',
          WebkitUserSelect: 'none'
        }}
        key={AnnotationUtil.getRootAnnotation(comment).getCommentId()}
        className={className}
        onMouseEnter={(evt) => this.onMouseEnterCommentMarker(evt)}
        onMouseLeave={(evt) => this.onMouseLeaveCommentMarker(evt)}
        draggable="false"
        {...clickProps}
        {...dragProps}
        {...attrs}>
        <span style={{ pointerEvents: 'none' }} draggable="false">
          {commentIdx}
        </span>
      </div>
    );
  }

  isShowingAllComments() {
    return this.props.showAllComments === CommentFilterOption.ALL;
  }

  isShowingResolvedComments() {
    return this.props.showAllComments === CommentFilterOption.RESOLVED;
  }

  isShowingUnresolvedComments() {
    return this.props.showAllComments === CommentFilterOption.UNRESOLVED;
  }

  drawDragArea() {
    const display = this.canvas.getDisplayProps();
    const commentDragArea = this.assetImagePreview.state.imageNormalFits
      ? {
        position: 'absolute',
        top: `calc(50% - ${display.height / 2}px)`,
        left: `calc(50% - ${display.width / 2}px)`,
        width: display.width,
        height: display.height,
        zIndex: 10
      }
      : {
        position: 'absolute',
        top: display.y,
        left: display.x,
        width: display.width,
        height: display.height,
        zIndex: 10
      };
    return (
      <div
        ref="dragArea"
        className="dragArea"
        style={commentDragArea}
        onMouseMove={(evt) => this.onCommentMarkerDrag(evt)}
        onMouseUp={(evt) => this.onCommentMarkerDragEnd(evt)}
      />
    );
  }

  onVideoProgress = (progress) => {
    if (!this.props[SHOW_COMMENTS]) {
      return;
    }

    [...document.querySelectorAll('[data-timecode]')].forEach((node) => {
      if (node.dataset.didFade) {
        return;
      }

      const timecode = parseInt(node.dataset.timecode, 10);
      if (Math.abs(timecode - progress) > 500) {
        node.dataset.didFade = true;
        $(node).fadeOut(250);
      }
    });
  };

  onVideoSeek = (progress) => {
    this.forceUpdate();
  };

  DCShapeDrawingStart = () => {
    this.SVGClickOff();
    this.shapeDrawStart = true;
  };

  DCShapeDrawingStop = () => {
    this.SVGClickOn();
    this.shapeDrawStart = false;
  };

  SVGClickOn = () => {
    let sourceDiv = this.props.isInFullscreenMode ? $('#fullscreenAssetView') : $('#defaultAssetView');
    if (this.props.compareViewRevisionIndex >= 0)
      sourceDiv = this.props.compareViewRevisionIndex ? $('#compareRevision1') : $('#compareRevision0');
    sourceDiv.on('click.placeComment', (event) => {
      if (event.target.nodeName === 'svg') {
        this.onSvgClick(event);
      }
    });
  };

  onSvgClick(event) {
    this.onClickOverImage(event);
    this.setState({
      browseCommentPosition: { x: event.clientX, y: event.clientY }
    });
  }

  SVGClickOff = () => {
    let sourceDiv = this.props.isInFullscreenMode ? $('#fullscreenAssetView') : $('#defaultAssetView');
    if (this.props.compareViewRevisionIndex >= 0)
      sourceDiv = this.props.compareViewRevisionIndex ? $('#compareRevision1') : $('#compareRevision0');
    sourceDiv.off('click.placeComment');
  };

  onClickOverImage = (event) => {
    const { canWriteComments } = this.props[PERMISSIONS];
    const comment = this.findActiveCommentByCommentId(this.props[ACTIVE_COMMENT_ID]);
    this.props.setSpatialBrowseComment(null);
    let browseBool = true;
    if (comment && comment.getAnnotationLocation().getSpatialLocation()) {
      browseBool = !this.state.browseComment;
    }
    if (!this.shapeDrawStart && browseBool && !this.state.browseCommentChain) {
      if (!this.state.addingComment && canWriteComments) {
        this.selectedCommentPosition({
          nativeEvent: {
            offsetX: event.offsetX,
            offsetY: event.offsetY
          }
        });
      }
    }
  };

  onClickOnCommentMarker = (evt, comment) => {
    evt.stopPropagation();
    this.onMarkerClick(evt, comment);
    this.props.onClickOnCommentMarker(comment);
    Store.put(ACTIVE_COMMENT_ID, comment.getThreadId());
  };

  onMouseEnterCommentMarker = (evt) => {
    $(evt.target).addClass('CommentMarkerGlow');
  };

  onMouseLeaveCommentMarker = (evt) => {
    $(evt.target).removeClass('CommentMarkerGlow');
  };

  selectedCommentPosition = (evt) => {
    if (this.isVideo()) {
      this.assetImagePreview.pause();
    }
    this.createNewComment(evt);
  };

  createNewComment(evt, shape = null, newComment = null) {
    const fuidRrnInfo = AnnotationUtil.toFuidRrnInfo(
      this.props.asset.getFuid(),
      this.props.asset.getBid(),
      this.props.asset.getRrn()
    );
    const collectionId = this.props.collection.getCollectionId();

    if (!newComment) {
      newComment = AnnotationUtil.createNewComment(fuidRrnInfo, collectionId);
      AnnotationUtil.setWidthAndHeightOffset(
        newComment,
        Math.floor(evt.nativeEvent.offsetX / this.canvas.state.scale),
        Math.floor(evt.nativeEvent.offsetY / this.canvas.state.scale)
      );
      if (this.isVideo()) {
        AnnotationUtil.setVideoTimeOffsetInMilliseconds(newComment, this.assetImagePreview.getProgressMillis());
      }
      if (this.props.isMultiPage) {
        AnnotationUtil.setPageNumber(newComment, this.assetImagePreview.state.currentPage);
      }

      newComment._annotationLocation._commentIndex = CommentUtil.maxCommentIndex(this.getValidComments()) + 1;
      AnnotationUtil.setRootReply(newComment, '');

      if (shape) {
        AnnotationUtil.attachSvgToAnnotationThread(newComment, 'drawing', shape);
      }
    }

    this.setState({ addingComment: { comment: newComment, placed: true }, clickedOnMarker: true });
    this.props.setSpatialBrowseComment(newComment, true);
  }

  onMarkerClick = (evt, comment) => {
    if (!this.state.addingComment && !this.state.editComment && !this.shapeDrawStart) {
      this.props.setSpatialBrowseComment(comment);
      this.setState({
        browseCommentPosition: { x: evt.clientX, y: evt.clientY },
        browseComment: comment,
        clickedOnMarker: true,
        formContainerOverrideStyle: {}
      });
    }
  };

  onCloseBrowseCommentChain = () => {
    this.setState({
      browseCommentChain: null,
      formContainerOverrideStyle: {}
    });
  };

  onResolveInPlaceComment = (comment, resolved) => {
    debug('[onResolveInPlaceComment()] args: ', { comment, resolved });
    if (this.props.fastRemoveResolvedComment) {
      this.props.fastRemoveResolvedComment(comment, resolved);
      if (!this.isShowingAllComments()) {
        this.onCloseBrowseCommentForm();
      }
    } else {
      this.onResolvedComment(comment, resolved);
    }
  };

  onCommentRemove = (comment) => {
    debug('[onCommentRemove()] comment: ', comment);
    const threadId = AnnotationUtil.getRootAnnotation(comment).getCommentId();
    AnnotationUtil.deleteAnnotation(AnnotationUtil.getRootAnnotation(comment).getCommentId(), (result, errId) => {
      const rrn: number = result;
      if (rrn > 0) {
        debug('[onCommentRemove()] root thread deleted. rrn: ', rrn, ' threadId: ', threadId);
        this.loadAnnotations();
        if (!this.props.useLocalComments) {
          if (this.props[COMMENTS]) {
            const comments = this.props[COMMENTS].filter((c) => c.getThreadId() !== comment.getThreadId());
            Store.put(COMMENTS, comments);
          }
        }
      } else {
        window.setError(errId.toString());
      }
    });
    this.replaceActiveComment(null);

    let comments;
    if (this.props.comments)
      comments = this.getValidComments().filter((el) => comment.getThreadId() !== el.getThreadId());
    else
      comments = _.remove(this.getValidComments(), (el) => {
        return comment.getThreadId() === el.getThreadId();
      });
    this.props.onReceiveComments(comments);
  };

  onEditInPlaceComment = (comment) => {
    debug('[onEditInPlaceComment()] comment: ', comment);
    this.onCloseBrowseCommentForm();
    this.setState({ editComment: comment, clickedOnMarker: true });
    this.props.setSpatialEditComment(comment);
  };

  onCloseBrowseCommentForm = () => {
    this.setState({
      browseCommentPosition: null,
      browseComment: null,
      clickedOnMarker: false,
      formContainerOverrideStyle: {}
    });
    this.props.setSpatialBrowseComment(null);
    if (this.canvas) {
      this.canvas.needUpdateOffsetY = true;
    }
    this.props.onCloseBrowseCommentForm();
  };

  onCommentMarkerDragStart = (evt, comment) => {
    if (!this.shapeDrawStart) {
      this.dragTimeout = setTimeout(() => {
        if (AnnotationUtil.isDrawingAttachments(comment)) {
          const commentIdx = comment.getAnnotation().getCommentId() + 1;
          const shape = $('#shape_' + commentIdx);
          this.canvas.refs.annotations.handleShapeClick(shape.get(0));
          if (shape.get(0).nodeName === 'line') {
            this.lineDragOrigin = {
              x1: parseInt(shape.attr('x1')),
              y1: parseInt(shape.attr('y1')),
              x2: parseInt(shape.attr('x2')),
              y2: parseInt(shape.attr('y2'))
            };
          }
          this.setState({ isDragging: comment, draggingShape: shape });
        } else {
          this.setState({ isDragging: comment });
        }
      }, 300);
    }
  };

  onCommentMarkerDrag = (evt) => {
    AnnotationUtil.setWidthAndHeightOffset(
      this.state.isDragging,
      Math.floor(evt.nativeEvent.offsetX / this.canvas.state.scale),
      Math.floor(evt.nativeEvent.offsetY / this.canvas.state.scale)
    );
    const { draggingShape } = this.state;
    if (draggingShape) {
      const { scale } = this.canvas.state;
      const width = parseInt(draggingShape.attr('width'));
      const height = parseInt(draggingShape.attr('height'));
      switch (draggingShape.get(0).nodeName) {
        case 'rect':
          this.canvas.refs.annotations.handleMarkerDrag({
            x: evt.nativeEvent.offsetX / scale - width / 2,
            y: evt.nativeEvent.offsetY / scale - height / 2
          });
          break;
        case 'ellipse':
          this.canvas.refs.annotations.handleMarkerDrag({
            x: evt.nativeEvent.offsetX / scale,
            y: evt.nativeEvent.offsetY / scale
          });
          break;
        case 'line':
          let { x1, y1, x2, y2 } = this.lineDragOrigin;
          const cx = parseInt((x1 + x2) / 2);
          const cy = parseInt((y1 + y2) / 2);
          const newCX = evt.nativeEvent.offsetX / scale;
          const newCY = evt.nativeEvent.offsetY / scale;
          let xDiff = newCX - cx;
          let yDiff = newCY - cy;
          x1 = x1 + xDiff;
          y1 = y1 + yDiff;
          x2 = x2 + xDiff;
          y2 = y2 + yDiff;
          this.canvas.refs.annotations.handleMarkerDrag({
            x1,
            y1,
            x2,
            y2
          });
          break;
      }
    }
    this.setState({ isDragging: this.state.isDragging });
  };

  onCommentMarkerDragEnd = () => {
    clearTimeout(this.dragTimeout);
    this.canvas.refs.annotations.handleShapeClickOff();
    this.lineDragOrigin = null;
    this.saveAnnotation(this.state.isDragging);
    this.setState({ isDragging: null, draggingShape: null });
  };

  onCommentButtonClick = () => {
    if (this.isVideo()) {
      this.assetImagePreview.pause();
      const videoRes = this.assetImagePreview.getVideoResolution();
      this.createNewComment({
        nativeEvent: {
          offsetX: (videoRes.width * this.canvas.state.scale) / 2,
          offsetY: (videoRes.height * this.canvas.state.scale) / 2
        }
      });
    } else {
      const width = this.assetImagePreview.state.imagePreviewResolutionX;
      const height = this.assetImagePreview.state.imagePreviewResolutionY;
      this.createNewComment({
        nativeEvent: {
          offsetX: (width * this.canvas.state.scale) / 2,
          offsetY: (height * this.canvas.state.scale) / 2
        }
      });
    }
  };

  onReplyEdit = (comment) => {
    debug('[onReplyEdit()] comment: ', comment);
    return this.saveAnnotation(comment);
  };

  onReplyRemove = async (comment, reply) => {
    try {
      debug('[onReplyRemove()] args: ', { comment, reply });
      await AnnotationUtil.deleteAnnotations([reply.getCommentId()]);
      _.remove(AnnotationUtil.getReplies(comment), (el) => {
        return el.getCommentId() === reply.getCommentId();
      });
      this.forceUpdate();
    } catch (err) {
      debug('[deleteReply()] error: ', err);
      window.setError(err.toString());
    }
  };

  onGotoPrevComment = (timestamp) => {
    if (this.commentTimestamps.length === 0) return;
    let goto = CommentUtil.findNearestLeft(this.commentTimestamps, timestamp);
    if (goto === 0) {
      goto = this.commentTimestamps.length - 1;
    }
    this.assetImagePreview.pause();
    this.assetImagePreview.seek(this.commentTimestamps[goto]);
  };

  onGotoNextComment = (timestamp) => {
    if (this.commentTimestamps.length === 0) return;
    let goto = CommentUtil.findNearestRight(this.commentTimestamps, timestamp);
    if (goto === this.commentTimestamps.length) {
      goto = 0;
    }
    this.assetImagePreview.pause();
    this.assetImagePreview.seek(this.commentTimestamps[goto]);
  };

  onNewComment = async (comment) => {
    try {
      await this.saveAnnotation(comment);
      Store.put(COMMENT_TEXT, '');
      this.setState({ addingComment: null, clickedOnMarker: false, formContainerOverrideStyle: {} });
    } catch (err) {
      debug('[onNewComment()] error: ', err);
    }
  };

  onNewReply = async (reply: string, comment: AnnotationThread) => {
    try {
      debug('[onNewReply()] args: ', { reply, comment });
      AnnotationUtil.appendNewReply(comment, reply);
      return await this.saveAnnotation(comment);
    } catch (err) {
      debug('[onNewReply()] error: ', err);
      AnnotationUtil.getReplies(comment).pop();
      window.setError(getErrorMessage(err));

      throw err;
    }
  };

  startProgressAnimation() {
    if (!this.savingAnnotations) {
      this.savingAnnotations = true;
      setGlobalProgress(true);
    }
  }

  stopProgressAnimation() {
    if (this.savingAnnotations) {
      setGlobalProgress(false);
    }
  }

  saveAnnotation = (comment, callbackFunc = null) => {
    debug('[saveAnnotation()] args: ', { comment, callbackFunc });
    if (!comment) {
      debug('[saveAnnotation()] no comment. return.');
      return;
    }

    const fuidRrnInfo = AnnotationUtil.toFuidRrnInfo(
      this.props.asset.getFuid(),
      this.props.asset.getBid(),
      this.props.asset.getRrn()
    );
    const collectionId = this.props.collection.getCollectionId();
    this.startProgressAnimation();
    return AnnotationUtil.saveAnnotation(fuidRrnInfo, comment, collectionId).then(
      (saveResp: SaveAnnotationsResponse) => {
        debug('[saveAnnotation()] response: ', saveResp);
        this.loadAnnotations(function () {
          comment._isSaving = false;
        });

        const comment = saveResp.getThreads()[0];

        if (comment.getThreadId()) {
          if (this.props.useLocalComments) {
            this.setState({ localComments: this.state.localComments.concat(comment) });
          } else {
            if (this.props[COMMENTS]) {
              const comments = this.props[COMMENTS].filter((c) => c.getThreadId() !== comment.getThreadId()).concat(
                comment
              );
              Store.put(COMMENTS, comments);
            }
          }
        }

        if (typeof callbackFunc === 'function') {
          callbackFunc(saveResp);
        }
      },
      (err) => {
        if (err.errorDetails != 'Nothing to do. Transaction aborted.') {
          debug('[saveAnnotation()] error: ', err);
          window.setError(getErrorMessage(err));
        }
        throw err;
      }
    );
  };

  onResolvedComment = async (comment: AnnotationThread, resolved: boolean) => {
    debug('[onResolvedComment()] args: ', { comment, resolved });
    try {
      const rrn: number = await AnnotationUtil.resolve(comment.getThreadId(), resolved);
      if (rrn > 0) {
        comment.setResolved(resolved);
      }
    } catch (errorId) {
      window.setError(errorId.toString());
    }
  };

  submitEditComment = async (comment: AnnotationThread) => {
    try {
      if (!comment) {
        return;
      }

      await this.saveAnnotation(comment);
      this.setState({ editComment: null, formContainerOverrideStyle: {} });
      Store.put(COMMENT_TEXT, '');
    } catch (err) {
      debug('[submitEditComment()] error: ', err);
      throw err;
    }
  };

  drawEditCommentChain() {
    let newStyle = {};
    if (this.state.clickedOnMarker) {
      const markerPos = this.calculateMarkerPosition({
        top: AnnotationUtil.getHeightOffset(this.state.editComment),
        left: AnnotationUtil.getWidthOffset(this.state.editComment)
      });
      newStyle = this.commentDivHorizontalPostion(markerPos.left);
      if (!markerPos) return null;
    }
    const style = Object.assign(this.getFormContainerStyle(this.state.editComment), newStyle);
    return (
      <div style={this.state.clickedOnMarker ? style : {}} ref={this.onCommentFormMount}>
        <EditCommentChain
          ref="editCommentChain"
          onClose={this.onEditDialogClose}
          onReply={this.onNewReply}
          onSubmit={this.onEditDialogSubmit}
          comment={this.state.editComment}
          onReplyEdit={this.onReplyEdit}
          onReplyRemove={this.onReplyRemove}
        />
      </div>
    );
  }

  onEditDialogClose = () => {
    this.setState({ editComment: null, browseComment: null, formContainerOverrideStyle: {} });
    this.props.onEditDialogClosed();
  };

  onEditDialogSubmit = async (comment: AnnotationThread) => {
    await this.submitEditComment(comment);
    this.props.onEditDialogClosed();
  };

  render() {
    return (
      <div
        ref="container"
        name="CollectionAssetView"
        style={{
          height: '100%',
          width: '100%',
          position: 'relative',
          cursor: this.state.isDragging ? 'move' : 'unset'
        }}>
        {this.drawAssetPreview()}
        {this.state.addingComment && !this.state.addingComment.global && this.drawNewComment()}
        {this.state.browseComment && this.state.clickedOnMarker && this.isVideo() && this.drawBrowseComment()}
        {this.state.browseCommentChain && this.state.clickedOnMarker && this.drawBrowseCommentChain()}
        {this.state.editComment && this.state.clickedOnMarker && this.drawEditCommentChain()}
        {this.isVideo() && this.drawCommentMarkers()}
        {this.state.isDragging && this.drawDragArea()}
      </div>
    );
  }

  getCanvas() {
    return this.canvas;
  }
}

const styles = {
  marker: {
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    position: 'absolute',
    color: 'var(--primary-header-bg)',
    transform: 'translateX(-50%) translateY(-50%)',
    lineHeight: '33px',
    textAlign: 'center',
    cursor: 'move',
    userSelect: 'none',
    WebkitUserSelect: 'none'
  }
};
